(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.controller('ConnectionTestController', function ($scope, $document, connectionService, $state) {

        function GetIEVersion() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf("MSIE");

            // If IE, return version number.
            if (Idx > 0)
                return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

            // If IE 11 then look for Updated user agent string.
            else if (!!navigator.userAgent.match(/Trident\/7\./))
                return 11;

            else
                return 0; //It is not IE
        }


        var prepare = function (id) {
            return Snap("#" + id);
        };

        var animateCircle = function (circle, fade, callback) {

            circle.animate(
                {
                    'stroke-dashoffset': 0
                }, 1000, mina.easeout, function () {
                    if (fade) {
                        fadeItem(circle, callback);
                    } else {
                        callback();
                    }

                });
        };

        var fadeItem = function (i, callback) {
            i.animate({
                'stroke-opacity': 0
            }, 400, callback);
        };
        var fadeInItem = function (i, callback) {
            i.animate({
                'stroke-opacity': 1
            }, 200, callback);
        };

        var resetItem = function (i) {

            i.attr('stroke-dasharray', i.getTotalLength());
            i.attr('stroke-dashoffset', i.getTotalLength());
            i.attr('stroke-opacity', 1);
        };


        $scope.bad = function () {
            $scope.displayOptions.connectionBad = true;
            $scope.displayOptions.breakLoop = true;

            if ($scope.blockAnimation === true) {

                var id1 = prepare('cross_seg1');
                id1.attr('stroke-dasharray', 0);
                id1.attr('stroke-dashoffset', 0);
                id1.attr('stroke-opacity', 1);
                id1.removeClass('hidden');

                var id2 = prepare('cross_seg2');
                id2.attr('stroke-dasharray', 0);
                id2.attr('stroke-dashoffset', 0);
                id2.attr('stroke-opacity', 1);
                id2.removeClass('hidden');

            }
        };
        $scope.good = function () {
            $scope.displayOptions.connectionGood = true;
            $scope.displayOptions.breakLoop = true;

            if ($scope.blockAnimation === true) {

                var id1 = prepare('minor');
                id1.removeClass('hidden');
                id1.attr('stroke-dasharray', 0);
                id1.attr('stroke-dashoffset', 0);
                id1.attr('stroke-opacity', 1);


                var id2 = prepare('major');
                id2.removeClass('hidden');
                id2.attr('stroke-dasharray', 0);
                id2.attr('stroke-dashoffset', 0);
                id2.attr('stroke-opacity', 1);


            }
        };

        $scope.displayOptions = {};

        $scope.displayOptions.breakLoop = false;
        $scope.displayOptions.connectionGood = false;
        var doLoop = function () {

            animateCircle(c, true, function () {
                if ($scope.displayOptions.breakLoop === false) {
                    resetItem(c);
                    doLoop();
                } else {
                    fadeInItem(c, function () {
                        if ($scope.displayOptions.connectionGood === true) {
                            showTick();
                        } else if ($scope.displayOptions.connectionBad === true) {
                            showCross();
                        }
                    });
                }
            });
        };

        $scope.blockAnimation = false;
        var c = prepare('Shape1');
        $scope.OnInit = function () {

            $scope.blockAnimation = (GetIEVersion() === 10 || GetIEVersion() === 11);

            //animateTarget(c,1000,function(){
            //});

            connectionService.gateway().then(function (response) {
                if (response.status === 200) {
                    return $scope.good();
                }

                return $scope.bad();

            }, function (errorResponse) {
                return $scope.bad();
            });

            if ($scope.blockAnimation === false) {
                resetItem(c);
                doLoop();
            }

        };

        var showTick = function () {
            twoStepAnimation('minor', 'major');
        };

        var showCross = function () {
            twoStepAnimation('cross_seg1', 'cross_seg2');
        };

        var twoStepAnimation = function (_inId1, _inId2) {

            var id2 = prepare(_inId2);
            resetItem(id2);


            var id1 = prepare(_inId1);
            resetItem(id1);
            id1.removeClass('hidden');

            id1.animate(
                {
                    'stroke-dashoffset': 0
                }, 300, mina.easeout, function () {

                    id2.removeClass('hidden');
                    id2.animate(
                        {
                            'stroke-dashoffset': 0
                        }, 300, mina.easeout, function () {

                        });
                });
        };

        $scope.retry = function () {
            $state.go('connectionTest', null, {
                reload: true
            });
        };

    });
})(window.angular);